class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);








// dev M code start


function getCurrentLocalePrefix() {
  // Adjust this regex if you have other locales (fr, de, etc.)
  const match = window.location.pathname.match(/^\/(ar|en|fr|de)(\/|$)/);
  return match ? `/${match[1]}` : '';
}

document.addEventListener('change', function (e) {
  if (e.target.classList.contains('quantity__input')) {
    const qty = parseInt(e.target.value, 10);
    const variantId = e.target.dataset.quantityVariantId;
    const localePrefix = getCurrentLocalePrefix();

    if (qty === 0) {
      fetch(`${localePrefix}/cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      })
      .then(res => res.json())
      .then(() => {
        return fetch(`${localePrefix}/cart.js`).then(res => res.json());
      })
      .then(cart => {
        return fetch(`${localePrefix}/?sections=cart-drawer,cart-icon-bubble`)
          .then(res => res.json())
          .then(data => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.setActiveElement(document.activeElement);
              cartDrawer.renderContents({
                id: variantId,
                sections: data
              });
            }

            setTimeout(() => {
              if (cart.item_count === 0) {
                const inner = document.querySelector('.drawer__inner');
                if (inner) {
                  inner.classList.add('is-empty');
                }
              }
            }, 50);
          });
      })
      .catch(err => console.error('Error removing item:', err));
    }
  }
});



// dev M cart recommendation products code start


/* =========================
   Locale utilities
========================= */
function getCurrentLocalePrefix() {
  const m = window.location.pathname.match(/^\/(ar|en|fr|de)(\/|$)/);
  return m ? `/${m[1]}` : '';
}

/* =========================
   Visibility helpers
========================= */
function isVisible(el) {
  return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
}

function hideWrapperIfAllHidden() {
  const products = Array.from(document.querySelectorAll('.cart-recommendation-product'));
  const anyVisible = products.some(p => isVisible(p));
  const wrappers = document.querySelectorAll('.cart-recommendation-products, .cart-recommendation-wrapper');
  wrappers.forEach(w => { if (w) w.style.display = anyVisible ? '' : 'none'; });
}

/* =========================
   Hide already-added recs
========================= */
function hideAlreadyAddedRecommendations(cart) {
  const cartProductIds = new Set((cart.items || []).map(it => it.product_id));

  document.querySelectorAll('.cart-recommendation-product').forEach(prodEl => {
    const productId = parseInt(prodEl.dataset.productId, 10);
    if (cartProductIds.has(productId)) {
      prodEl.style.display = 'none';
    }
  });

  hideWrapperIfAllHidden();
}

/* =========================
   Add recommended product
========================= */
document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form.classList || !form.classList.contains('buy-it-with-form')) return;

  e.preventDefault();
  const localePrefix = getCurrentLocalePrefix();
  const select = form.querySelector('select[name="id"]');
  const variantId = select && select.value;
  if (!variantId) { alert('Please select a size.'); return; }

  const productEl = form.closest('.cart-recommendation-product');
  const btn = form.querySelector('.add-to-cart-button');
  if (btn) btn.disabled = true;

  if (productEl) productEl.style.display = 'none';
  hideWrapperIfAllHidden();

  fetch(`${localePrefix}/cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(() => fetch(`${localePrefix}/?sections=cart-drawer,cart-icon-bubble`))
  .then(res => res.json())
  .then(sections => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.setActiveElement(document.activeElement);
      cartDrawer.renderContents({ id: variantId, sections });
    }
  })
  .then(() => fetch(`${localePrefix}/cart.js`))
  .then(res => res.json())
  .then(cart => hideAlreadyAddedRecommendations(cart))
  .catch(err => {
    console.error(err);
    if (productEl) productEl.style.display = '';
    hideWrapperIfAllHidden();
    alert('Error adding product to cart');
  })
  .finally(() => {
    if (btn) btn.disabled = false;
  });
});

/* =========================
   Remove item when qty = 0
========================= */
document.addEventListener('change', function (e) {
  const input = e.target;
  if (!input.classList || !input.classList.contains('quantity__input')) return;

  const qty = parseInt(input.value, 10);
  if (!Number.isFinite(qty)) return;

  if (qty === 0) {
    const variantId = input.dataset.quantityVariantId;
    const localePrefix = getCurrentLocalePrefix();

    fetch(`${localePrefix}/cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    })
    .then(res => res.json())
    .then(() => fetch(`${localePrefix}/?sections=cart-drawer,cart-icon-bubble`))
    .then(res => res.json())
    .then(sections => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
        cartDrawer.renderContents({ id: variantId, sections });
      }
    })
    .then(() => fetch(`${localePrefix}/cart.js`))
    .then(res => res.json())
    .then(cart => {
      hideAlreadyAddedRecommendations(cart);
      if (cart.item_count === 0) {
        const inner = document.querySelector('.drawer__inner');
        if (inner) inner.classList.add('is-empty');
      }
    })
    .catch(err => console.error('Error removing item:', err));
  }
});

/* =========================
   Variant change in cart drawer (remove old + add new)
========================= */
document.addEventListener('change', function (e) {
  const select = e.target;
  if (!select.classList || !select.classList.contains('cart-option-select')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const newValue = select.value;
  const optionIndex = parseInt(select.dataset.optionIndex, 10);
  const productHandle = select.dataset.productHandle;
  const cartItemKey = select.dataset.cartItemKey; // old line item key
  const localePrefix = getCurrentLocalePrefix();

  // Step 1: Get product data to find new variant ID
  fetch(`${localePrefix}/products/${productHandle}.js`)
    .then(res => res.json())
    .then(product => {
      const matchingVariant = product.variants.find(variant => {
        return variant.options[optionIndex] === newValue;
      });
      if (!matchingVariant) throw new Error('Variant not found');

      // Step 2: Remove old line item
      return fetch(`${localePrefix}/cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cartItemKey, quantity: 0 })
      }).then(() => matchingVariant.id);
    })
    .then(newVariantId => {
      // Step 3: Add new variant
      return fetch(`${localePrefix}/cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: newVariantId, quantity: 1 })
      });
    })
    .then(() => fetch(`${localePrefix}/?sections=cart-drawer,cart-icon-bubble`))
    .then(res => res.json())
    .then(sections => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ sections });
      }
    })
    .then(() => fetch(`${localePrefix}/cart.js`))
    .then(res => res.json())
    .then(cart => hideAlreadyAddedRecommendations(cart))
    .catch(err => {
      console.error('Error changing variant:', err);
      alert('Error updating variant');
    });
}, true); // capture phase

/* =========================
   On load: hide recs already in cart
========================= */
document.addEventListener('DOMContentLoaded', function () {
  const localePrefix = getCurrentLocalePrefix();
  fetch(`${localePrefix}/cart.js`)
    .then(res => res.json())
    .then(cart => hideAlreadyAddedRecommendations(cart))
    .catch(() => {});
});


// dev M cart recommendation products code end

// dev M code end